import moment from 'moment-timezone';
import { emDashUnicode } from '../../../utilities/constants';

export const CONTRACT_TYPE_MAP = {
  SOP: 'SOP',
  NON_SOP: 'Non-SOP',
  NA: 'NA',
};

export const CONTRACT_SOURCE = {
  AFP: 'AFP',
  LEGACY: 'legacy',
  NA: 'NA',
};

export const getContractPeriod = (solPeriod) => {
  return solPeriod?.contractPeriod || emDashUnicode;
};

export const isContractSOP = (purchaseTypeCode) => {
  return purchaseTypeCode === 'S' || purchaseTypeCode === 'Y';
};

export const getContractType = (purchaseTypeCode) => {
  if (purchaseTypeCode === 'S' || purchaseTypeCode === 'Y') {
    return CONTRACT_TYPE_MAP.SOP;
  }
  if (
    purchaseTypeCode === 'M' ||
    purchaseTypeCode === 'E' ||
    purchaseTypeCode === 'O' ||
    purchaseTypeCode === 'N'
  ) {
    return CONTRACT_TYPE_MAP.NON_SOP;
  }
  return CONTRACT_TYPE_MAP.NA;
};

const defaultFleetContractYear = '2021';

// if fleetAwarded is 0 or null, it is a legacy contract
export const isLegacyContract = (fleetAwarded) => {
  return fleetAwarded === null || fleetAwarded === 0;
};

export const getContractYear = (contract) => {
  const contractType = getContractType(
    contract?.solicitation?.purchaseTypeCode,
  );

  switch (contractType) {
    case CONTRACT_TYPE_MAP.SOP:
      // if either contractYear or renewalYear is less than 2021, return defaultContractYear
      if (contract?.renewalYear) {
        return contract.renewalYear > defaultFleetContractYear
          ? contract.renewalYear
          : defaultFleetContractYear;
      }

      if (contract?.contractYear) {
        return contract.contractYear > defaultFleetContractYear
          ? contract.contractYear
          : defaultFleetContractYear;
      }

      return emDashUnicode;
    case CONTRACT_TYPE_MAP.NON_SOP:
      return contract?.solicitation?.contractYear || emDashUnicode;
    default:
      return emDashUnicode;
  }
};

// Date time helpers
const ET = 'America/New_York';
export const getETString = (utcStr) =>
  utcStr ? moment(utcStr).tz(ET).format('YYYY-MM-DD HH:mm') : null;
export const getUTCString = (etStr) =>
  etStr
    ? moment.tz(etStr, ET).utc().format('YYYY-MM-DDTHH:mm:ss.sss[Z]')
    : null;
export const formatDatePickerValue = (value) =>
  moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD');

export const getISODateStr = (date, emptyValue = emDashUnicode) => {
  if (!date) return emptyValue;
  const d = new Date(date);
  if (isNaN(d.getTime())) return emptyValue;
  return Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC',
    dateStyle: 'short',
  }).format(d);
};

export const getUSDateTimeStr = (date, emptyValue = emDashUnicode) => {
  if (!date) return emptyValue;
  const d = new Date(date);
  if (isNaN(d.getTime())) return emptyValue;
  return Intl.DateTimeFormat('en-US', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(d);
};

export const getETDateTimeStr = (
  date,
  suffix = '',
  emptyValue = emDashUnicode,
) => {
  if (!date) return emptyValue;
  const d = new Date(date);
  if (isNaN(d.getTime())) return emptyValue;
  return (
    Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(d) + suffix
  );
};
